/* ==========================================================================
   KARISMAI 货币显示引擎（display-only）
   - 汇率：jsDelivr 开源 currency-api，localStorage 缓存 24h，内置兜底汇率
   - 默认 US / USD；仅按访客手动选择切换（自动定位已停用，检测不稳定）
   - 改价：文本节点扫描 + MutationObserver，只改显示，结算仍为 USD
   - 失败模式：任何环节出错 → 保持显示 USD，绝不显示错价
   ========================================================================== */
(function () {
  'use strict';

  var RATES_URL = 'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/usd.json';
  var LS_FX = 'kar_fx_v1';
  var LS_CUR = 'kar_cur_v1';
  var FX_TTL = 24 * 60 * 60 * 1000;

  /* 国家 → 货币 */
  var C2C = {
    US:'USD', CA:'CAD', GB:'GBP', AU:'AUD', NZ:'NZD', JP:'JPY', KR:'KRW', SG:'SGD',
    HK:'HKD', TW:'TWD', CN:'CNY', MY:'MYR', TH:'THB', PH:'PHP', ID:'IDR', VN:'VND',
    IN:'INR', AE:'AED', SA:'SAR', IL:'ILS', TR:'TRY', CH:'CHF', NO:'NOK', SE:'SEK',
    DK:'DKK', PL:'PLN', CZ:'CZK', HU:'HUF', RO:'RON', BG:'BGN', MX:'MXN', BR:'BRL',
    AR:'ARS', CL:'CLP', ZA:'ZAR',
    AT:'EUR', BE:'EUR', HR:'EUR', CY:'EUR', EE:'EUR', FI:'EUR', FR:'EUR', DE:'EUR',
    GR:'EUR', IE:'EUR', IT:'EUR', LV:'EUR', LT:'EUR', LU:'EUR', MT:'EUR', NL:'EUR',
    PT:'EUR', SK:'EUR', SI:'EUR', ES:'EUR', MC:'EUR'
  };

  var SYM = {
    USD:'$', EUR:'€', GBP:'£', AUD:'A$', CAD:'C$', NZD:'NZ$', JPY:'¥',
    KRW:'₩', SGD:'S$', HKD:'HK$', TWD:'NT$', CNY:'¥', MYR:'RM', THB:'฿',
    PHP:'₱', IDR:'Rp', VND:'₫', INR:'₹', AED:'AED', SAR:'SAR',
    ILS:'₪', TRY:'₺', CHF:'CHF', NOK:'kr', SEK:'kr', DKK:'kr', PLN:'zł',
    CZK:'Kč', HUF:'Ft', RON:'lei', BGN:'лв', MXN:'MX$', BRL:'R$',
    ARS:'AR$', CLP:'CLP$', ZAR:'R'
  };

  var DEC0 = { JPY:1, KRW:1, TWD:1, HUF:1, CLP:1, VND:1, IDR:1 };

  /* 兜底汇率（2026-08 快照，仅在网络与缓存都不可用时使用） */
  var FALLBACK = {
    EUR:0.863, GBP:0.739, AUD:1.396, CAD:1.372, NZD:1.52, JPY:160.1, KRW:1335,
    SGD:1.29, HKD:7.8, TWD:30.4, CNY:7.12, MYR:4.2, THB:32.5, PHP:56.5, IDR:15600,
    VND:25400, INR:84.0, AED:3.673, SAR:3.75, ILS:3.35, TRY:41.0, CHF:0.80,
    NOK:10.1, SEK:9.5, DKK:6.44, PLN:3.68, CZK:21.1, HUF:340, RON:4.29, BGN:1.69,
    MXN:18.7, BRL:5.4, ARS:1350, CLP:930, ZAR:17.6
  };

  var state = { cur: 'USD', iso: 'US', rates: null };

  /* ---------- 工具 ---------- */
  function safeGet(key) { try { return JSON.parse(localStorage.getItem(key)); } catch (e) { return null; } }
  function safeSet(key, v) { try { localStorage.setItem(key, JSON.stringify(v)); } catch (e) {} }

  function rateFor(cur) {
    if (cur === 'USD') return 1;
    if (state.rates && state.rates[cur.toLowerCase()]) return state.rates[cur.toLowerCase()];
    if (FALLBACK[cur]) return FALLBACK[cur];
    return null;
  }

  function format(usd, cur) {
    var r = rateFor(cur);
    if (r === null) return null;
    var v = usd * r;
    var dec = DEC0[cur] ? 0 : 2;
    /* 原价是整数（本店 USD 定价均为整数）时，换算估价也取整，更符合品牌调性 */
    if (usd === Math.round(usd)) { dec = 0; v = Math.round(v); }
    var num;
    try {
      num = v.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    } catch (e) {
      num = v.toFixed(dec);
    }
    return (SYM[cur] || cur + ' ') + num;
  }

  /* ---------- 汇率 ---------- */
  function loadRates() {
    var cached = safeGet(LS_FX);
    if (cached && cached.t && Date.now() - cached.t < FX_TTL && cached.rates) {
      state.rates = cached.rates;
      return Promise.resolve();
    }
    return fetch(RATES_URL)
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j && j.usd) {
          state.rates = j.usd;
          safeSet(LS_FX, { t: Date.now(), rates: j.usd });
        }
      })
      .catch(function () { /* 用兜底表 */ });
  }

  /* ---------- 改价引擎 ---------- */
  /* 匹配 $1,234.56 / $425.00 USD / $425，避开已包裹的节点 */
  var MONEY_RE = /\$\s?(\d{1,3}(?:,\d{3})*(?:\.\d{1,2})?)(\s*USD)?/g;

  function shouldSkip(node) {
    var el = node.parentElement;
    if (!el) return true;
    if (el.closest('script, style, noscript, textarea, input, [data-kar-cvt], [data-kar-no-convert], .kar-curdrawer, .kar-locale')) return true;
    return false;
  }

  function tagPrices(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('$') === -1) return NodeFilter.FILTER_REJECT;
        if (shouldSkip(n)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var targets = [];
    while (walker.nextNode()) targets.push(walker.currentNode);

    targets.forEach(function (textNode) {
      var text = textNode.nodeValue;
      MONEY_RE.lastIndex = 0;
      if (!MONEY_RE.test(text)) return;
      MONEY_RE.lastIndex = 0;

      var frag = document.createDocumentFragment();
      var last = 0, m;
      while ((m = MONEY_RE.exec(text)) !== null) {
        var usd = parseFloat(m[1].replace(/,/g, ''));
        if (isNaN(usd) || usd <= 0) continue;
        if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var span = document.createElement('span');
        span.setAttribute('data-kar-cvt', '');
        span.setAttribute('data-usd', String(usd));
        span.setAttribute('data-orig', m[0]);
        span.textContent = m[0];
        frag.appendChild(span);
        last = m.index + m[0].length;
      }
      if (last === 0) return;
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  function repaint() {
    document.querySelectorAll('[data-kar-cvt]').forEach(function (el) {
      if (state.cur === 'USD') {
        el.textContent = el.getAttribute('data-orig');
        return;
      }
      var out = format(parseFloat(el.getAttribute('data-usd')), state.cur);
      el.textContent = out !== null ? out : el.getAttribute('data-orig');
    });
    updateTriggers();
  }

  function updateTriggers() {
    document.querySelectorAll('[data-kar-cur-label]').forEach(function (el) {
      el.textContent = (SYM[state.cur] || '') + ' ' + state.cur;
    });
    document.querySelectorAll('[data-kar-cur-flag]').forEach(function (el) {
      el.className = 'az-country-flags az-country-flags--' + state.iso;
    });
    document.querySelectorAll('[data-kar-cur-option]').forEach(function (el) {
      el.classList.toggle('is-current', el.getAttribute('data-iso') === state.iso);
    });
  }

  var moTimer = null;
  function observe() {
    new MutationObserver(function () {
      clearTimeout(moTimer);
      moTimer = setTimeout(function () {
        tagPrices(document.body);
        if (state.cur !== 'USD') repaint();
      }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- 选择与定位 ---------- */
  function setCurrency(iso, opts) {
    state.iso = iso;
    state.cur = C2C[iso] || 'USD';
    safeSet(LS_CUR, { iso: state.iso, cur: state.cur, manual: !(opts && opts.auto) });
    repaint();
  }

  function detectOnce() {
    var saved = safeGet(LS_CUR);
    if (saved && saved.iso) {
      state.iso = saved.iso;
      state.cur = saved.cur || (C2C[saved.iso] || 'USD');
      return Promise.resolve();
    }
    /* 自动定位已停用（检测结果不稳定，会来回跳变）：
       未手动选择过的访客一律默认 US / USD。
       如日后要恢复，用 /browsing_context_suggestions.json 的 detected_values.country.handle。 */
    return Promise.resolve();
  }

  /* ---------- 抽屉交互 ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-kar-curdrawer]');
    if (!drawer) return;

    function open() {
      drawer.classList.add('is-open');
      document.documentElement.classList.add('kar-drawer-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      /* 移动端可能是从导航抽屉里打开的 —— 导航抽屉还开着时保留滚动锁 */
      var navOpen = document.querySelector('[data-kar-drawer].is-open');
      if (!navOpen) {
        document.documentElement.classList.remove('kar-drawer-open');
        document.body.style.overflow = '';
      }
    }

    document.querySelectorAll('[data-kar-cur-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    drawer.querySelectorAll('[data-kar-cur-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    /* 填充每行的目标货币 */
    drawer.querySelectorAll('[data-kar-cur-option]').forEach(function (btn) {
      var iso = btn.getAttribute('data-iso');
      var cur = C2C[iso] || 'USD';
      var cell = btn.querySelector('[data-kar-cur-cell]');
      if (cell) cell.textContent = cur + ' ' + (SYM[cur] || '');
      btn.addEventListener('click', function () {
        setCurrency(iso);
        var form = drawer.querySelector('form');
        var input = drawer.querySelector('[data-kar-cur-input]');
        var currentIso = input ? input.getAttribute('data-current') : null;
        var shopCur = btn.getAttribute('data-shopify-cur');
        var curShopCur = input ? input.getAttribute('data-current-cur') : null;
        close();
        /* 仅当 Shopify 端结算货币真的会变化时才刷新页面同步市场上下文。
           未开通 Shopify Payments 时所有市场都是 USD —— 永不刷新，纯前端即时换算，
           也避免 /localization 302 跳回 myshopify 域导致 localStorage 偏好丢失。 */
        if (form && input && currentIso && currentIso !== iso && shopCur && curShopCur && shopCur !== curShopCur) {
          input.value = iso;
          form.submit();
        }
      });
    });
  }

  /* ---------- 启动 ---------- */
  function boot() {
    detectOnce().then(function () {
      return loadRates();
    }).then(function () {
      tagPrices(document.body);
      repaint();
      observe();
      initDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.KarCurrency = {
    set: function (iso) { setCurrency(iso); },
    get current() { return { iso: state.iso, currency: state.cur }; }
  };
})();
